import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-status-ld',
  templateUrl: './status-ld.page.html',
  styleUrls: ['./status-ld.page.scss']
})
export class StatusLdPage implements OnInit {
  days: any = [];

  constructor(
    private navParams: NavParams,
    private modalCtrl: ModalController
  ) {}

  onClickDay(day) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.modalCtrl.dismiss({ ymd: day.ymd });
  }

  dismiss() {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.modalCtrl.dismiss();
  }

  ngOnInit() {
    const allDays = this.navParams.data.days;
    this.days = allDays.filter((d) => d.incompleteCount > 0);
  }
}
